<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="6" >
         <el-cascader ref='cascader2'
          style="width:100%;"
          v-model="theBusinessType" clearable filterable
          size='small'
          placeholder='请选择分类'
          :show-all-levels='false'
          :options="getBusinessTypeListAll_data ? getBusinessTypeListAll_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: false, emitPath: false, label: 'btName', value: 'btId', children: 'children' }"
          @change="theBusinessTypeChange" >
          <template slot-scope="{ data }" >
            <span onclick="this.parentNode.previousElementSibling.click()" >{{ data.btName }}</span>
          </template>
        </el-cascader>
      </el-col>
      <el-col :span="6">
        <el-select v-model='theBusinessIds' size="small" multiple clearable style="width:100%;" placeholder='请选择业务'>
            <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class='flex'>
        <el-input
          v-model="getBusinessAttrResultList_data.attrName"
          placeholder="请输入商机关联名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          @click="doSearch"
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          @click=" $form('addBusinessAttrResult'),
          getBusinessAttrList({projectId:theProjectId,pageSize:0}),
          getProjectBusiness({projectId:theProjectId,pageSize:0})"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加商机关联
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getBusinessAttrResultList'
      api='getBusinessAttrResultList'
      xupdateapi='updateBusinessAttrResult'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addBusinessAttrResult:    [ "新增商机关联信息", "el-icon-circle-plus" ],
        updateBusinessAttrResult: [ "修改商机关联信息", "el-icon-edit-outline"],
        $succeed$: getBusinessAttrResultList
      }'
      @close='$form("addBusinessAttrResult","reset")' 
      @confirm='myform'>
      <hide slot='barId' />
      <hide slot='projectId' />
      <template v-slot:bIds="{Myformdata}" >
        <el-select v-model='Myformdata.bIds' size="small" multiple clearable style="width:100%;" @change="bIdsChange">
            <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:businessIds="{Myformdata}" >
        <el-select v-model='Myformdata.businessIds' multiple clearable style="width:100%;">
            <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:attrIds="{Myformdata}" >
        <el-select v-model='Myformdata.attrIds' clearable multiple style="width:100%;" >
             <el-option
                v-for="item in getBusinessAttrList_data.data||[]"
                :key="item.attrId"
                :label="item.attrKey +'--'+ item.attrName"
                :value="item.attrId">
            </el-option>
        </el-select>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attrId: null,
      theProjectId:"",
      theBusinessIds:"",
      theBusinessType:"",

      tableColums_getBusinessAttrResultList: {
        $selection: false,

        businessNames: '推荐业务名称',

        attrIds: '属性',

        businessIds: '业务',

        barDescribe: '推荐语',
        
        barUrl: '关联文件',

        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateBusinessAttrResult && `@text: 编辑#success
           @click: 
            typeof $row.attrIds === 'string' && ( $row.attrIds = JSON.parse($row.attrIds) );
            typeof $row.businessIds === 'string' && ( $row.businessIds = JSON.parse($row.businessIds) );
            $form("updateBusinessAttrResult",$row);
            getBusinessAttrList({projectId:theProjectId,pageSize:0});
            getProjectBusiness({projectId:theProjectId,pageSize:0});
          `,
          this.deleteBusinessAttrResult && `@text: 删除#danger
           @click: _confirm('确定要删除该商机关联吗?')
                   .trigger('deleteBusinessAttrResult',{barId:$row.barId})
                   .trigger('getBusinessAttrResultList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    theBusinessTypeChange(e){
      this.theBusinessId="";
      this.theBusinessType=e;
      this.getBusinessList({pageSize:0,businessIds:this.theBusinessType});
    },
    bIdsChange(e){
      console.log(e)
      this.getBusinessAttrList({projectId:this.theProjectId,pageSize:0,bIds:e.join()})
    },
    myform(submit, Myformdata) {
      // Myformdata.projectId = this.theProjectId;
      submit();
    },
    doSearch(){
      this.getBusinessAttrResultList({projectId:this.theProjectId,businessIds:this.theBusinessIds});
    }
  },

  created() {
    this.getBusinessTypeListAll();
    this.getBusinessAttrResultList({projectId:this.theProjectId});
    this.getBusinessList({pageSize:0,businessIds:this.theBusinessType});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/ModelManage.vue